import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { useMediaQuery, Grid, Button, Typography } from '@material-ui/core';
import { Image } from 'components/atoms';
import { SectionHeader } from 'components/molecules';
import {Box} from '@material-ui/core'

const useStyles = makeStyles(theme => ({

    font:{
        fontSize:'18px'
    },
  image: {
    boxShadow:
      '25px 60px 125px -25px rgba(80,102,144,.1), 16px 40px 75px -40px rgba(0,0,0,.2)',
    borderRadius: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      maxWidth: 500,
    },
  },
}));

const Herm= props => {
  const { className, ...rest } = props;
  const classes = useStyles();

  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <Box  className={className} {...rest} marginBottom={2} marginLeft= {2} marginRight={2} marginTop= {2} display="flex" justifyContent="space-evenly" alignItems="center" padding={6} border="1px solid #ccc" borderRadius="4px">
      <Grid
        container
        justify="space-between"
        spacing={4}
        direction={isMd ? 'row' : 'column-reverse'}
      >
        <Grid
          item
          container
          alignItems="center"
          xs={12}
          md={6}
          data-aos={'fade-up'}
        >
          <SectionHeader
            title={
              <span>
        ASKION C-line® 
                <br />
                <Typography component="span" variant="inherit" color="primary">
        Hermetic Storage
                </Typography>
              </span>
            }
          
            align="left"
            disableGutter
            titleVariant="h3"

            />
            <ul className = {classes.font}>
                <li>
            Configurable for a wide variety of sample formats, e.g., Straws, vials, blood bags, etc.

                </li>

                <li>
            Patented hood system with a cryogenic working range of up to -110 ° C in the gas phase of LN

                </li>
                <li>
            Two handling procedures with individually heated gloves.
                </li>
                <li>
            Sample storage below -150 ° C in the gas phase of LN2.


                </li>
                <li>
            Integrated barcode scanner (1D / 2D).


                </li>

                <li>
            Modular with internal full automation can be retrofitted at -100 ° C.


                </li>

                <li>
            External automation for linking individual storage systems to a fully automated biobank.


                </li>

                <li>
            Sample management controls storage and retrieval processes.


                </li>


               
            </ul>

            <SectionHeader
            ctaGroup={[
              <Button variant="contained" color="primary" size="large">
                Quickbook
              </Button>,
              <Button variant="outlined" color="primary" size="large">
              Talk to us
              </Button>,
            ]}
            align="left"
            disableGutter
            titleVariant="h3"
          />
        </Grid>
        <Grid
          item
          container
          justify="flex-start"
          alignItems="center"
          xs={12}
          md={6}
          data-aos={'fade-up'}
        >
          <Image
            src="https://onwhicar.sirv.com/premas/main/askion/clinehermitic-askion.png"
            alt="Hermitage"
            className={classes.image}
            data-aos="flip-left"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="2000"
          />
        </Grid>
      </Grid>
    </Box>
  );
};

Herm.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
};

export default Herm;
